var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20.9063C25.5228 20.9063 30 16.4291 30 10.9063C30 5.3834 25.5228 0.90625 20 0.90625C14.4772 0.90625 10 5.3834 10 10.9063C10 16.4291 14.4772 20.9063 20 20.9063Z",
    fill: "#1BC186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5469 2.63282C26.6406 4.1797 27.2734 6.08595 27.2734 8.1797C27.2734 13.7266 22.8203 18.1797 17.2734 18.1797C15.1797 18.1797 13.2734 17.5469 11.7266 16.4531C13.5469 19.0859 16.5469 20.9063 20 20.9063C25.5469 20.9063 30 16.4531 30 10.9063C30 7.45313 28.2734 4.3672 25.5469 2.63282Z",
    fill: "#1BC186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 39.0938H4.54688C4 39.0938 3.64062 38.7266 3.64062 38.1875V16.3672H22.7344V39.0938H22.7266Z",
    fill: "#D8A23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 39.0938H4.54688C4 39.0938 3.64062 38.7266 3.64062 38.1875V16.3672H22.7344V39.0938H22.7266Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 39.0938H35.4531C36 39.0938 36.3594 38.7266 36.3594 38.1875V16.3672H22.7266V39.0938Z",
    fill: "#D8A23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 39.0938H35.4531C36 39.0938 36.3594 38.7266 36.3594 38.1875V16.3672H22.7266V39.0938Z",
    fill: "#FFD164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54688 38.1797V27.2734C4.54688 26.2734 5.36719 25.4531 6.36719 25.4531H20.1875C20.6406 25.4531 21.0078 25.1797 21.0938 24.7266L22.7266 16.3594H4.54688H3.63281V25.4531V38.1797C3.63281 38.7266 4 39.0859 4.53906 39.0859H22.7188C22.1719 38.5391 21.3516 38.1797 20.5391 38.1797H4.54688Z",
    fill: "#D8A23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4531 16.3672H22.7266L24.3594 24.7344C24.4531 25.1875 24.8125 25.4609 25.2656 25.4609H33.6328C34.6328 25.4609 35.4531 26.2813 35.4531 27.2813V38.1875H24.9062C24.0859 38.1875 23.2734 38.5547 22.7266 39.0938H35.4531C36 39.0938 36.3594 38.7266 36.3594 38.1875V25.4531V16.3672H35.4531Z",
    fill: "#BB800E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2734 23.6328H39.0938C39.6406 23.6328 40 23.1797 40 22.7266C40 22.5469 40 22.3594 39.8203 22.2734L36.3672 16.3672H22.7266L26.7266 22.8203C27.0938 23.2734 27.6328 23.6328 28.2734 23.6328Z",
    fill: "#FFD164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 23.6328H0.90625C0.359375 23.6328 0 23.1797 0 22.7266C0 22.5469 0 22.3594 0.179688 22.2734L3.63281 16.3672H22.7266L18.7266 22.8203C18.3672 23.2734 17.8203 23.6328 17.1797 23.6328Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 32.7266H11.3594C11.6328 32.7266 11.8125 32.9063 11.8125 33.1797C11.8125 33.4531 11.6328 33.6328 11.3594 33.6328H5.90625C5.63281 33.6328 5.45312 33.4531 5.45312 33.1797C5.45312 32.9063 5.63281 32.7266 5.90625 32.7266Z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 34.5469H9.53906C9.8125 34.5469 9.99219 34.7266 9.99219 35C9.99219 35.2734 9.8125 35.4531 9.53906 35.4531H5.90625C5.63281 35.4531 5.45312 35.2734 5.45312 35C5.45312 34.7266 5.63281 34.5469 5.90625 34.5469Z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.4141C19.7969 14.4141 19.6016 14.3359 19.4453 14.1875L16.7188 11.4609C16.4141 11.1563 16.4141 10.6641 16.7188 10.3594C17.0234 10.0547 17.5156 10.0547 17.8203 10.3594L19.9922 12.5313L24.8906 7.63281C25.1953 7.32812 25.6875 7.32812 25.9922 7.63281C26.2969 7.9375 26.2969 8.42969 25.9922 8.73438L20.5391 14.1875C20.3984 14.3438 20.2031 14.4141 20 14.4141Z",
    fill: "#1BC186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 13.5078C18.8828 13.5078 18.6875 13.4219 18.5391 13.2812L15.8125 10.5547C15.5078 10.25 15.5078 9.7578 15.8125 9.45312C16.1172 9.14843 16.6094 9.14843 16.9141 9.45312L19.0859 11.625L23.9922 6.71874C24.2969 6.41405 24.7891 6.41405 25.0938 6.71874C25.3984 7.02343 25.3984 7.51562 25.0938 7.8203L19.6406 13.2812C19.5 13.4297 19.2969 13.5078 19.0938 13.5078Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.5dcc08275bd4e6cc83770c6436c4afc2.svg";
export { ForwardRef as ReactComponent };